<template>
  <section class="page-wrapper">
    <div v-if="$wait.any" class="loading-wrapper">
      <LoadingBounce/>
    </div>

    <section class="quiz-wrapper" v-else>
      <NewClassLcAudio
        :audio="audio"
        :auto-play="true"
        :key="audio.id"
        v-for="audio in quiz.audios"
      />

      <QuizHeader :pageType="quiz.page_type"/>

      <NewClassContentViewer
        :page="quiz"
        :content="quiz.content"
        :isOXQuiz="isOXQuiz(quizAnswers)"
      />

      <template
        v-if="
          quizTypeName === 'multiple_choice' &&
          quiz.answer_view_type === 'control'
        "
      >
        <NewClassOptions :options="options"/>
        <NewClassOptionsControl
          :quiz="this.quiz"
          :isSolvedQuiz="true"
          :isAssigneeView="isAssigneeView"
        />
      </template>

      <NewClassOptionsListControl
        v-if="
          quizTypeName === 'multiple_choice' &&
          quiz.answer_view_type === 'list' &&
          !isOXQuiz(quizAnswers)
        "
        :quiz="this.quiz"
        :isSolvedQuiz="true"
        :isAssigneeView="isAssigneeView"
      />

      <QuizOXControl
        v-if="
          quizTypeName === 'multiple_choice' &&
          quiz.answer_view_type === 'list' &&
          isOXQuiz(quizAnswers)
        "
        :quiz="quiz"
        :options="quizAnswers"
      />

      <NewClassPreviewQuizResult
        v-if="quizTypeName !== 'non_quiz'"
        :quiz="quiz"
        :quizResult="quizResult"
        :isOXQuiz="isOXQuiz(quizAnswers)"
        :isAssigneeView="isAssigneeView"
        :isSolvedQuiz="true"
      />

      <NewClassQuizDescription
        v-if="quizDescriptionShow"
        :quiz="quiz"
        :content="quiz.description"
      />
    </section>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { orderBy, get, find } from 'lodash';
import quiz from '@/mixins/quiz';
import NewClassPreviewQuizResult from '../components/NewClassPreviewQuizResult';
import NewClassOptions from '../components/NewClassOptions';
import NewClassOptionsControl from '../components/NewClassOptionsControl';
import NewClassOptionsListControl from '../components/NewClassOptionsListControl';
import NewClassContentViewer from '../components/NewClassContentViewer';
import NewClassQuizDescription from '../components/NewClassQuizDescription';
import NewClassLcAudio from '../components/NewClassLcAudio';

export default {
  name: 'new-class-preview-pages-show',
  components: {
    NewClassPreviewQuizResult,
    NewClassOptions,
    NewClassOptionsControl,
    NewClassOptionsListControl,
    NewClassContentViewer,
    NewClassQuizDescription,
    NewClassLcAudio,
  },
  mixins: [quiz],

  props: ['isAssigneeView'],

  data() {
    return {
      options: null,
    };
  },

  computed: {
    ...mapGetters({
      routeParams: 'getRouteParams',
      quiz: 'getCurrentPageForNewClass',
      gradingStatus: 'getGradingStatusForNewClass',
    }),

    currentPageResult() {
      return this.getPagesResult[this.quiz.id];
    },

    quizDescriptionShow() {
      if (this.isAssigneeView) {
        if (this.quizTypeName === 'non_quiz') {
          return false;
        } else if (this.quizTypeName === 'essay_type') {
          return this.gradingStatus;
        }
      }

      if (!this.isAssigneeView) {
        if (this.quizTypeName === 'non_quiz') {
          return false;
        } else if (this.quizTypeName === 'essay_type') {
          return this.gradingStatus;
        }
      }
      return true;
    },

    isStoreCard() {
      return this.routeParams.cardType === 'store-cards';
    },

    quizAnswers() {
      const optionId = this.isStoreCard ? 'copy_id' : 'id';
      if (!get(this.quiz, 'id')) return [];
      return orderBy(this.options, [optionId], ['asc']);
    },

    quizTypeName() {
      if (!get(this.quiz, 'id')) return '';
      return get(this.quiz, 'page_type.name');
    },

    quizResult() {
      if (!get(this.quiz, 'id')) return {};
      return find(this.options, { is_correct: true });
    },
  },

  beforeMount() {
    if (this.isStoreCard) {
      this.options = this.quiz.options;
    } else {
      this.options = this.quiz.answers;
    }
  },

  watch: {
    quiz() {
      if (this.isStoreCard) {
        this.options = this.quiz.options;
      } else {
        this.options = this.quiz.answers;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-wrapper {
  margin-top: 180px;
  height: 100%;
}

.page-wrapper {
  height: calc(100vh - 77px);
  user-select: none;
  background: #ffffff;
  overflow-y: auto;
}

.quiz-wrapper {
  .quiz-header {
    padding-left: 14px;

    .quiz-type {
      .quiz-label {
        font-size: 14px;
        font-weight: 700;
        color: rgba(0, 0, 0, 0.54);
      }
    }
  }
}
</style>
